<template lang="pug">
.shadow-size-text(@click="close")
  .container-size-text(@click.stop="")
    h3 {{ index >= 0 ? 'Editando...' : 'Nuevo Texto' }}
    .properties-text
      .input-container-color
        span Color
        input.input-color(type="color" v-model="color")
      .input-container.arrow.select-size-container
        select.select.select-size(v-model="size" autocomplete="ño")
          option(:value="5") 5
          option(:value="6") 6
          option(:value="7") 7
          option(:value="8") 8
          option(:value="9") 9
          option(:value="10") 10
          option(:value="11") 11
          option(:value="12") 12
          option(:value="13") 13
          option(:value="14") 14
          option(:value="15") 15
          option(:value="16") 16
          option(:value="17") 17
          option(:value="18") 18
        label.label(:class="{ show: size }") Tamaño

      .input-container.arrow.select-size-container
        select.select.select-size(v-model="degrees" autocomplete="ño")
          option(:value="0") 0
          option(:value="15") 15
          option(:value="30") 30
          option(:value="45") 45
          option(:value="60") 60
          option(:value="75") 75
          option(:value="90") 90
          option(:value="105") 105
          option(:value="120") 120
          option(:value="135") 135
          option(:value="150") 150
          option(:value="165") 165
          option(:value="180") 180
          option(:value="195") 195
          option(:value="210") 210
          option(:value="225") 225
          option(:value="240") 240
          option(:value="255") 255
          option(:value="270") 270
          option(:value="285") 285
          option(:value="300") 300
          option(:value="315") 315
          option(:value="330") 330
          option(:value="345") 345
        label.label(:class="{ show: degrees }") Grados
    div(v-for="(size, index) in sizes")
      .container-measure
        .input-container
          input.input(v-model="sizes[index]" type="text")
          label.label Talla
        .input-container
          input.input(v-model="values[index]" type="text")
          label.label Medida
        div(:class="{hidden: !index}")
          shActionButton(:action="deleteSize" :params="[index]" text="x" textRunning="x" :mini="true")

    .left
      shActionButton(:action="addSize" text="+" textRunning="+" :mini="true")

    .last-buttons.left
      shActionButton(:action="close" text="Salir" textRunning="Salir")
      shActionButton(:action="save" text="Guardar" textRunning="Guadando" :principalColor="true")
</template>

<script>
import mForm from '@/mixins/form'
import modals from '@my/store/modals'

export default {
  name: 'SizeText',

  mixins: [mForm],

  props: {
    sizesEdit: { type: Array, default: () => [] },
    valuesEdit: { type: Array, default: () => [] },
    colorEdit: { type: String, default: '' },
    sizeEdit: { type: Number, default: 10 },
    degreesEdit: { type: Number, default: 0 },
    index: { type: Number, default: -1 }
  },

  data () {
    return {
      sizes: [''],
      values: [''],
      color: '#ffffff',
      size: 10,
      degrees: 0
    }
  },

  mounted () {
    if (this.sizesEdit.length) this.sizes = [...this.sizesEdit]
    if (this.valuesEdit.length) this.values = [...this.valuesEdit]
    if (this.colorEdit) this.color = this.colorEdit
    if (this.sizeEdit) this.size = this.sizeEdit
    if (this.degreesEdit) this.degrees = this.degreesEdit
  },

  methods: {
    addSize () {
      this.sizes.push('')
      this.values.push('')
    },

    deleteSize (index) {
      if (index === 0) return
      this.sizes.splice(index, 1)
      this.values.splice(index, 1)
    },

    close () {
      this.$emit('close')
    },

    save () {
      let allValuesComplete = true

      this.values.forEach((value, index) => {
        if (!value) {
          modals.showMessage({ message: `La fila ${index + 1} no tiene valor`, type: 'error' })
          allValuesComplete = false
        }
      })

      if (allValuesComplete) {
        this.$emit('close')
        if (this.index >= 0) {
          this.$emit('update', { sizes: this.sizes, values: this.values, color: this.color, size: this.size, index: this.index, degrees: this.degrees })
          return
        }
        this.$emit('save', { sizes: this.sizes, values: this.values, color: this.color, size: this.size, degrees: this.degrees })
      }
    }
  }
}
</script>

<style lang="stylus">
.shadow-size-text
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  background-color rgba(0, 0, 0, .4)
  display flex
  justify-content center
  align-items center
  z-index 100
  cursor pointer

.container-size-text
  width 100%
  max-width 50em
  padding 1em
  background-color var(--background-principal)
  cursor default

.container-measure
  display flex
  gap 1em
  align-items center

.last-buttons
  margin-top 1em
  display flex
  gap 1em

.select-size-container
  width 10em

.properties-text
  gap 1em

.properties-text, .input-container-color
  display flex
  align-items center
</style>



// WEBPACK FOOTER //
// src/components/elements/dimensions/SizeText.vue